export default __webpack_public_path__ + "static/media/frg--orchard-parklands.1dfde628.png";